import React from 'react';
import Layout from '../Layouts';
import NonAuthLayout from './NonAuthLayout';


const ConditionalLayout = ({ children }) => {
    const userDetails = localStorage.getItem("userDetails");
  
    // Sidebar & header should show if user logged in even once
    const showDashboardLayout = !!userDetails;
  
    return showDashboardLayout 
      ? <Layout>{children}</Layout>
      : <NonAuthLayout>{children}</NonAuthLayout>;
  };
  
  export default ConditionalLayout;